define('collections/wallet_histories',['require','collections/base','models/wallet_history'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/wallet_history");

    return BaseCollection.extend({
        model: Model,
        url: 'wallet-histories.json'
    });
});
